import { type BoardTaskStatus } from '../../../../../common/types/task';
import { type BoardTasksState } from '../tasksSlice';

export const removeFromStatus = (
  idsByStatus: BoardTasksState['idsByStatus'],
  status: BoardTaskStatus,
  id: number
) => {
  const list = idsByStatus[status];
  const index = list.indexOf(id);
  if (index !== -1) list.splice(index, 1);
};
